import React from "react";
import {Card, Input, Checkbox, Button, Typography,} from "@material-tailwind/react";
import {InboxArrowDownIcon} from "@heroicons/react/24/outline";
import GoogleIcon from '@mui/icons-material/Google';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';

const RegPage=()=>{
   return(
    <>
        <div className='flex justify-center'>
             
    <Card color="transparent" shadow={false}>
     
      <h2 className='text-[#001ad2] font-bold md:text-3xl text-2xl md:text-left text-center'> Sign Up </h2>
      <h1 className='lg:text-sm text-xs mt-3 text-red-600'>
        * All fields are mendotery
      </h1>
      <form className="mt-2 mb-2 w-80 max-w-screen-lg sm:w-96">
        <div className="mb-1 flex flex-col gap-4">
          <Input size="md" label="Enter User Name" required />
          <Input size="md" type='email' label="Enter Email ID" required />
          <Input size="md" type='date' label="Select Date of Birth" required />
          <Input size="md" type='mobile' label="Enter Mobile No." required />
          <Input type="password" size="md" label="Password" required/>
        </div>
        <div className="flex justify-start">
        <Checkbox 
          label={
            (
              <Typography
                variant="small"
                color="gray"
                className="flex items-center font-normal"
              >
                I agree the
                <a href="/" className="font-medium transition-colors hover:text-blue-500">
                  &nbsp;Terms and Conditions
                </a>
              </Typography>
            )
          }
          containerProps={{ className: "-ml-2.5" }}
        />
        </div>
        
       
        <Button type='submit' className="flex items-center justify-center gap-3 w-full mt-1 bg-[#001ad2]">
          <InboxArrowDownIcon strokeWidth={2} className="h-5 w-5" /> Register
      </Button>

      <div className='flex justify-center mt-3 text-gray-500 text-sm'>
      ------------ or continue with: ------------
      </div>
      <div className='flex justify-center gap-4 pt-3'>
        <Button size="sm" className='bg-red-500 rounded-full h-8 w-8 p-0'> <GoogleIcon className='text-white-500' style={{ fontSize:'15px' }}/> </Button>
        <Button size="sm" className='bg-blue-800 h-8 w-8 rounded-full p-0'><FacebookOutlinedIcon className='text-white-500' style={{ fontSize:'18px' }}/>  </Button>
        <Button size="sm" className='bg-blue-400  h-8 w-8  rounded-full p-0'> <TwitterIcon className='text-white-500' style={{ fontSize:'15px' }}/> </Button>
      </div>
      

      </form>
    </Card>
 
        </div>
    </>
   )
};

export default RegPage;